import {Pipe, PipeTransform} from '@angular/core';
import {DateTimeService} from './date-time.service';

@Pipe({
	name: 'formatDateTime'
})
export class FormatDateTimePipe implements PipeTransform {


	constructor(private dateTimeService: DateTimeService) {
	}

	/**
	 * @param input - unix timestamp in ms
	 * @return formatted date time
	 */
	transform(input: number): string {
		return this.dateTimeService.getDateTimeFromUnixTimestamp(input);
	}

}
